import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { NoPreloading, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';

import { appRoutes } from './app.routes';
import { provideTransloco } from './core/services/transloco/transloco.provider';
import { provideIcons } from './core/services/icons/icons.provider';
import { provideFuse } from '@fuse';
import { mockApiServices } from './mock-api';
import { SharedComponentsModule } from './core/components/shared-components.module';
import { SharedModule } from './core/shared.module';
import { ApiModule } from './api/api.module';
import { environment } from 'environments/environment';
import { TokenInterceptor } from './api/services/cookie-jwt-auth/interceptors/token.interceptor';
import { ColorPickerModule } from 'ngx-color-picker';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection(),
        provideAnimations(),
        provideRouter(appRoutes,
            withPreloading(NoPreloading),
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
        ),
        provideHttpClient(withInterceptorsFromDi()),

        // Bridge remaining NgModules
        importProvidersFrom(
            SharedModule,
            SharedComponentsModule,
            ColorPickerModule,
            ApiModule.forRoot({ rootUrl: environment.apiURL }),
        ),

        // HTTP interceptors
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },

        // Material Date Adapter
        {
            provide: DateAdapter,
            useClass: LuxonDateAdapter,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'D',
                },
                display: {
                    dateInput: 'DDD',
                    monthYearLabel: 'LLL yyyy',
                    dateA11yLabel: 'DD',
                    monthYearA11yLabel: 'LLLL yyyy',
                },
            },
        },

        // Transloco Config
        provideTransloco(),

        // Icons
        provideIcons(),

        // Fuse
        provideFuse({
            mockApi: {
                delay: 0,
                services: mockApiServices,
            },
            fuse: {
                layout: 'classy',
                scheme: 'light',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                },
                theme: 'theme-default',
                themes: [
                    {
                        id: 'theme-default',
                        name: 'Default',
                    },
                    {
                        id: 'theme-nexus',
                        name: 'Nexus',
                    },
                    {
                        id: 'theme-brand',
                        name: 'Brand',
                    },
                    {
                        id: 'theme-teal',
                        name: 'Teal',
                    },
                    {
                        id: 'theme-rose',
                        name: 'Rose',
                    },
                    {
                        id: 'theme-purple',
                        name: 'Purple',
                    },
                    {
                        id: 'theme-amber',
                        name: 'Amber',
                    },
                ],
            },
        }),
    ],
};
